var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWallet(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_56643",
    "data-name": "Group 56643",
    transform: "translate(-972 -242.005)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_17236",
    "data-name": "Rectangle 17236",
    width: 64,
    height: 64,
    transform: "translate(972 242.005)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "noun-4841682",
    d: "M67.87,23.585,67.264,20.2a6.463,6.463,0,0,0-7.522-5.252l-45.32,8.023a6.466,6.466,0,0,0-2.594,1.083,6.464,6.464,0,0,0-3.45,5.712V59.435A6.464,6.464,0,0,0,14.843,65.9H65.915a6.464,6.464,0,0,0,6.464-6.464V29.766a6.464,6.464,0,0,0-4.509-6.181Zm.509,25.7H64.1a3.458,3.458,0,0,1-2.578-1.042,3.329,3.329,0,0,1-.978-2.424,3.466,3.466,0,0,1,3.612-3.232h4.234ZM60.453,18.955a2.424,2.424,0,0,1,2.836,1.98l.412,2.351H35.923Zm5.47,42.928H14.867a2.424,2.424,0,0,1-2.424-2.424V29.766a2.465,2.465,0,0,1,2.448-2.448H66.028a2.423,2.423,0,0,1,2.351,2.424v8.831H64.2a7.361,7.361,0,0,0-5.559,12.548,7.545,7.545,0,0,0,5.317,2.206h4.42V59.4h0a2.424,2.424,0,0,1-2.464,2.48Z",
    transform: "translate(963.621 233.634)",
    fill: "#0b6972"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWallet);
export default __webpack_public_path__ + "static/media/wallet.954b64d1692273002ad462bac08da970.svg";
export { ForwardRef as ReactComponent };